"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
class Button {
    static init() {
        const rippleBtn = document.querySelectorAll('.btn--ripple');
        const ripples = document.createElement('div');
        if (rippleBtn === null || ripples === null) {
            return;
        }
        rippleBtn.forEach((button) => {
            button.addEventListener('mouseover', (e) => {
                const rect = button.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;
                ripples.style.left = x + 'px';
                ripples.style.top = y + 'px';
                button.appendChild(ripples);
            });
            button.addEventListener('mouseout', function () {
                ripples.remove();
            });
        });
    }
}
exports.Button = Button;
